export default __webpack_public_path__ + "media/images/logo-2d126279c25d747ea5dcee22b6d39b50.svg";